import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as React from 'react';
export default {
  GatsbyImage,
  getImage,
  React
};